
@switch (vendorType) {
  @case ('KYRUUS') {
    <app-doctor-detail-kyruus
      [vendorType]="vendorType"
      [plan]="plan"
    ></app-doctor-detail-kyruus>
  }
  @case ('SAPPHIRE_DIGITAL') {
    <app-doctor-detail-sapphire-digital
      [vendorType]="vendorType"
      [plan]="plan"
    ></app-doctor-detail-sapphire-digital>
  }
  @default {
    Choose a provider vendor
  }
}
